<!-- ============================================================= -->
<!-- NEW DESIGN — /jobs   (3-column job page)                      -->
<!-- ============================================================= -->
<div class="gj-page">

  <!-- ===================== TOOLBAR ===================== -->
  <div class="gj-toolbar" role="search" aria-label="Search and filter jobs">
    <div class="gj-toolbar-inner">

      <div class="gj-search">
        <svg class="gj-search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input #Search placeholder="Search Job Title, Job ID, Skills" type="search" [formControl]="searchControl"
          class="gj-search-input" autocomplete="off" />
      </div>

      <div class="gj-toolbar-divider" aria-hidden="true"></div>

      <div class="gj-chips" [formGroup]="filterForm" id="scrollContainer">

        <!-- Posted Days Filter -->
        <button type="button" class="gj-chip gj-chip--active" [matMenuTriggerFor]="menu1">
          Posted (Days) <span class="gj-chip-count">1</span>
          <svg class="gj-chip-icon" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="6 9 12 15 18 9" /></svg>
        </button>
        <mat-menu #menu1="matMenu" [class]="'gj-filter-menu'">
          <div class="checkboxclassRadio" (click)="$event.stopPropagation();">
            <div class="col-sm-12 border-none">
              <div class="filter-title form-group">
                <span class="card-header- tab-title custom-text "><b> Posted (Days)</b></span>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="postedDayRange" [value]="POSTED_ANY"
                  style="display: none;" type="radio" id="exampleRadio00">
                <label class="form-check-label custom-radio-label custom-text " for="exampleRadio00"
                  (click)="onPostedDaysChange(POSTED_ANY)">
                  {{POSTED_ANY}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="postedDayRange" [value]="POSTED_TODAY"
                  style="display: none;" type="radio" id="exampleRadio11">
                <label class="form-check-label custom-radio-label custom-text " for="exampleRadio11"
                  (click)="onPostedDaysChange(POSTED_TODAY)">
                  {{POSTED_TODAY}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="postedDayRange" [value]="POSTED_LAST_7_DAYS"
                  style="display: none;" type="radio" id="exampleRadio44">
                <label class="form-check-label custom-radio-label custom-text " for="exampleRadio44"
                  (click)="onPostedDaysChange(POSTED_LAST_7_DAYS)">
                  {{POSTED_LAST_7_DAYS}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="postedDayRange" [value]="POSTED_LAST_14_DAYS"
                  style="display: none;" type="radio" id="exampleRadio22">
                <label class="form-check-label custom-radio-label custom-text " for="exampleRadio22"
                  (click)="onPostedDaysChange(POSTED_LAST_14_DAYS)">
                  {{POSTED_LAST_14_DAYS}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="postedDayRange" [value]="POSTED_LAST_30_DAYS"
                  style="display: none;" type="radio" id="exampleRadio33">
                <label class="form-check-label custom-radio-label custom-text " for="exampleRadio33"
                  (click)="onPostedDaysChange(POSTED_LAST_30_DAYS)">
                  {{POSTED_LAST_30_DAYS}}
                </label>
              </div>
            </div>
          </div>
        </mat-menu>

        <!-- Experience Filter -->
        <button type="button" class="gj-chip gj-chip--active" [matMenuTriggerFor]="menu2">
          Experience (Years) <span class="gj-chip-count">1</span>
          <svg class="gj-chip-icon" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="6 9 12 15 18 9" /></svg>
        </button>
        <mat-menu #menu2="matMenu" [class]="'gj-filter-menu'">
          <div class="checkboxclassRadio" (click)="$event.stopPropagation();">
            <div class="col-sm-12 border-none">
              <div class="filter-title form-group">
                <span class="card-header- tab-title custom-text "><b> Experience (Years)</b></span>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="experienceType" [value]="EXPERIENCE_ANY"
                  style="display: none;" type="radio" id="exampleRadio0">
                <label class="form-check-label custom-radio-label custom-text" for="exampleRadio0"
                  (click)="onExperienceValueChange(EXPERIENCE_ANY)">
                  {{EXPERIENCE_ANY}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="experienceType" [value]="EXPERIENCE_JUNIOR"
                  style="display: none;" type="radio" id="exampleRadio1">
                <label class="form-check-label custom-radio-label  custom-text" for="exampleRadio1"
                  (click)="onExperienceValueChange(EXPERIENCE_JUNIOR)">
                  {{EXPERIENCE_JUNIOR}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="experienceType" [value]="EXPERIENCE_MID_LEVEL"
                  style="display: none;" type="radio" id="exampleRadio12">
                <label class="form-check-label custom-radio-label  custom-text" for="exampleRadio12"
                  (click)="onExperienceValueChange(EXPERIENCE_MID_LEVEL)">
                  {{EXPERIENCE_MID_LEVEL}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="experienceType" [value]="EXPERIENCE_SENIOR"
                  style="display: none;" type="radio" id="exampleRadio3">
                <label class="form-check-label custom-radio-label  custom-text" for="exampleRadio3"
                  (click)="onExperienceValueChange(EXPERIENCE_SENIOR)">
                  {{EXPERIENCE_SENIOR}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="experienceType" [value]="EXPERIENCE_ARCHITECT"
                  style="display: none;" type="radio" id="exampleRadio4">
                <label class="form-check-label custom-radio-label  custom-text" for="exampleRadio4"
                  (click)="onExperienceValueChange(EXPERIENCE_ARCHITECT)">
                  {{EXPERIENCE_ARCHITECT}}
                </label>
              </div>
            </div>
          </div>
        </mat-menu>

        <!-- Engagement Type Filter -->
        <button type="button" class="gj-chip" [ngClass]="{'gj-chip--active': engagementTypeCount > 0}" [matMenuTriggerFor]="menu3">
          Engagement Type
          <span *ngIf="engagementTypeCount > 0" class="gj-chip-count">{{engagementTypeCount}}</span>
          <svg class="gj-chip-icon" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="6 9 12 15 18 9" /></svg>
        </button>
        <mat-menu #menu3="matMenu" [class]="'gj-filter-menu'">
          <div class="content-container-mini-loader" (click)="$event.stopPropagation();">
            <section>
              <div class="filter-title col-sm-12 form-group">
                <span class="card-header- tab-title"><b> Engagement Type </b></span>
              </div>
              @for(checkbox of jobclasscificationCheckboxes; track checkbox.label; let i = $index; let lastItem =
              $last){
              <div class="col-sm-12">
                <div class="custom-checkbox" title=" {{checkbox.label}}">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" [disabled]="checkbox.disable" [(ngModel)]="checkbox.selected"
                      [ngModelOptions]="{standalone: true}" (change)="jobclassficheckbox(checkbox.label , $event)" />
                    <span class="checkmark"></span>
                    <p class="label-ppp"> {{ checkbox.label }}</p>
                  </label>
                </div>
              </div>
              }
            </section>
          </div>
        </mat-menu>

        <!-- Work Mode Filter -->
        <button type="button" class="gj-chip" [ngClass]="{'gj-chip--active': workTypeCount > 0}" [matMenuTriggerFor]="menu4">
          Work Mode
          <span *ngIf="workTypeCount > 0" class="gj-chip-count">{{workTypeCount}}</span>
          <svg class="gj-chip-icon" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="6 9 12 15 18 9" /></svg>
        </button>
        <mat-menu #menu4="matMenu" [class]="'gj-filter-menu'">
          <div class="content-container-mini-loader" (click)="$event.stopPropagation();">
            <div class="col-sm-12 p-0">
              <div class="filter-title col-sm-12 form-group">
                <span class="card-header- tab-title"><b> Work Mode </b></span>
              </div>
              <div class="d-flex flex-column">
                @for(checkbox of workModeCheckboxes; track checkbox.label){
                <div class="custom-checkbox d-flex">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" [checked]="checkbox.selected"
                      (change)="workModeChange($event.target , checkbox.label)" />
                    <span class="checkmark"></span>
                    <p class="label-ppp"> {{checkbox.label}}</p>
                  </label>
                </div>
                }
              </div>
            </div>
          </div>
        </mat-menu>

        <!-- Location Filter -->
        <button type="button" class="gj-chip" [ngClass]="{'gj-chip--active': locationCount > 0}" [matMenuTriggerFor]="menu5">
          Location
          <span *ngIf="locationCount > 0" class="gj-chip-count">{{locationCount}}</span>
          <svg class="gj-chip-icon" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="6 9 12 15 18 9" /></svg>
        </button>
        <mat-menu #menu5="matMenu" [class]="'gj-filter-menu gj-filter-menu--wide'" xPosition="before" style="width: auto !important;">
          <div class="content-container-mini-loader" (click)="$event.stopPropagation();">
            <div class="filter-title">
              <span class="card-header- tab-title"><b> Location </b></span>
            </div>
            <div class="col-sm-12 d-flex flex-column gap-2">
              <div class="row app-form form-group">
                <div class="col-sm-6">
                  <!-- mat-select, not a native <select>: the browser draws a
                       native list as tall as it likes (~20 rows) and CSS
                       can't cap it. This panel is height-capped and
                       scrollable (.gj-filter-select-panel in style.scss). -->
                  <!-- gjSelectTypeahead: native-select letter jumping (press U
                       repeatedly to step through the U countries). -->
                  <mat-select class="form-control input-sm gj-filter-select" formControlName="country"
                    placeholder="Country" panelClass="gj-filter-select-panel" aria-label="Country"
                    gjSelectTypeahead (selectionChange)="onChangeCountry()">
                    <mat-option *ngFor="let country of countryList" [value]="country.countryCode"
                      [attr.title]="country.countryName">
                      {{ country.countryName }}
                    </mat-option>
                  </mat-select>
                </div>
                <div class="col-sm-6" *ngIf="filterForm.value.country == 'US'">
                  <input type="text" maxlength="11" (input)="digitKeyOnly($event)" placeholder="Zip Code"
                    formControlName="zipCode" class="form-control input-sm" (keyup)="onKeyZip($event)" />
                </div>
                @if(stateList && stateList.length > 0){
                <div class="col-sm-6">
                  <mat-select class="form-control input-sm gj-filter-select" formControlName="state"
                    placeholder="State" panelClass="gj-filter-select-panel" aria-label="State"
                    gjSelectTypeahead (selectionChange)="onChangestate()">
                    <mat-option *ngFor="let state of stateList" [value]="state.stateName"
                      [attr.title]="state.stateName">
                      {{ state.stateName }}
                    </mat-option>
                  </mat-select>
                </div>
                }
                @else if (filterForm.value.country != 'US'){
                <div class="col-sm-6">
                  <input type="text" maxlength="50" placeholder="State" formControlName="state"
                    class="form-control input-sm" (input)="onChangestate()" />
                </div>
                }
              </div>
              <div class="row form-group app-form">
                <div class="col-sm-6" *ngIf="filterForm.value.country == 'US'">
                  <input type="text" maxlength="50" placeholder="City" formControlName="city" (input)="onChangecity()"
                    class="form-control input-sm" />
                </div>
                <div class="col-sm-6" *ngIf="filterForm.value.country != 'US'">
                  <input type="text" maxlength="50" placeholder="City" formControlName="city" (input)="onChangecity()"
                    class="form-control input-sm" />
                </div>
                <div class="col-sm-6" *ngIf="filterForm.value.country != 'US'">
                  <input type="text" maxlength="11" placeholder="Zip Code" (input)="digitKeyOnly($event)"
                    formControlName="zipCode" (input)="onChangeZipCode($event)" class="form-control input-sm" />
                </div>
                <div class="col-sm-6" *ngIf="filterForm.value.country == 'US'">
                  <input type="text" maxlength="50" placeholder="State" formControlName="state"
                    (input)="onChangestate()" class="form-control input-sm" />
                </div>
              </div>
            </div>
          </div>
        </mat-menu>

      </div>

      <div class="gj-toolbar-right">
        <button class="gj-reset" type="button" (click)="resetFilternew()" aria-label="Reset all filters">Reset</button>
      </div>

    </div>
  </div>

  <!-- ===================== BREADCRUMB ===================== -->
  <div class="gj-breadcrumb-wrap">
    <nav aria-label="Breadcrumb">
      <ol class="gj-breadcrumb">
        <li class="gj-bc-item">
          <a routerLink="/" class="gj-bc-link">Home</a>
          <svg class="gj-bc-sep" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="9 18 15 12 9 6" /></svg>
        </li>
        <li class="gj-bc-item">
          <a routerLink="/jobs" class="gj-bc-link">Jobs</a>
          <svg class="gj-bc-sep" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="9 18 15 12 9 6" /></svg>
        </li>
        <li class="gj-bc-item">
          <span class="gj-bc-current" aria-current="page">{{ jobData.getJob?.jobTitle || 'Jobs' }}</span>
        </li>
      </ol>
    </nav>
  </div>

  <!-- ===================== PAGE GRID ===================== -->
  <main class="gj-page-wrap">

    <!-- LEFT — job list -->
    <aside class="gj-list-col" aria-label="Job listings">
      <div class="gj-jl-header">
        <span class="gj-jl-count" aria-live="polite">{{ totalCountJob }} Jobs Found</span>
      </div>

      <div class="gj-jl-cards">
        <ng-container *ngFor="let items of (response | async)">
          <app-job-card [view]="'small'" *ngIf="!loadAPIcall" [updateJobModule]="jobModule"
            [loadAPIcall]="loadAPIcall" [Obj]="selectedJobData" [responseReceived]="responseReceived"
            [jobsFoundStatus]="jobsFoundStatus" [passValues]="items"></app-job-card>
        </ng-container>

        <app-skeleton-loaders *ngIf="loadAPIcall" [case]="'job-card'" [items]="3"></app-skeleton-loaders>

        <div class="gj-empty" *ngIf="!loadAPIcall && apiCompleted && (response | async)?.length === 0">
          <app-svg-templates [svgType]="'NOT-FOUND-100'"></app-svg-templates>
          <p>Couldn't find any Jobs for the applied filters.</p>
        </div>
      </div>

      <app-custom-pagination
        *ngIf="!loadAPIcall && (response | async)?.length > 0"
        [config]="paginationConfig"
        [showPageInfo]="true"
        (pageChange)="onPageChange($event)">
      </app-custom-pagination>
    </aside>

    <!-- MIDDLE — job detail -->
    <article class="gj-detail-col" aria-label="Job detail">
      <app-skeleton-loaders *ngIf="loadAPIcall" [case]="'job-candidate-detail'"></app-skeleton-loaders>
      <app-job-details *ngIf="!loadAPIcall"></app-job-details>
      <div class="gj-empty-lg" *ngIf="!loadAPIcall && apiCompleted && (response | async)?.length === 0">
        <app-svg-templates [svgType]="'NO_DATA'"></app-svg-templates>
        <h6>There's nothing to show here.</h6>
      </div>
    </article>

    <!-- RIGHT — sidebar -->
    <aside class="gj-sidebar-col" aria-label="Apply and related jobs">
      <app-skeleton-loaders *ngIf="loadAPIcall" [case]="'job-sidebar'"></app-skeleton-loaders>
      <app-job-sidebar *ngIf="!loadAPIcall"></app-job-sidebar>
    </aside>

  </main>

  <!-- ===================== MOBILE APPLY BAR ===================== -->
  <div class="gj-mobile-apply" *ngIf="!loadAPIcall && jobData.getJob?.jobId != null">
    <div class="gj-mobile-apply-inner">
      <div class="gj-mobile-apply-info">
        <p class="gj-mobile-rate">
          {{ gigsumoService.formatRateRange(jobData.getJob?.targetRateFrom, jobData.getJob?.targetRateTo, jobData.getJob?.country, jobData.getJob?.payType) || '—' }}
        </p>
        <p class="gj-mobile-sub">{{ jobData.getJob?.jobClassification }}<span *ngIf="jobData.getJob?.workMode"> · {{ jobData.getJob?.workMode }}</span></p>
      </div>
      <a class="gj-mobile-cta"
         [class.gj-disabled]="!jobData.getJob?.availability || jobData.getJob?.status != 'ACTIVE'"
         target="_blank" rel="noopener noreferrer" href="{{ getLoginParams(jobData.getJob) }}">Apply Now</a>
    </div>
  </div>

</div>
